import {Component, input} from '@angular/core'
import {AbstractControl, FormControl} from '@angular/forms'
import {MatButton} from '@angular/material/button'
import {MatIcon} from '@angular/material/icon'
import {generate} from '@sparbanken-syd/personnummer'
import {environment} from '../../../environments/environment'

@Component({
  selector: 'spb-random-pnr',
  templateUrl: './random-pnr.component.html',
  styleUrls: ['./random-pnr.component.scss'],
  imports: [MatButton, MatIcon]
})
export class RandomPnrComponent {

  readonly control = input<AbstractControl>(new FormControl()
    /**
     * Test functions available?
     */
  )

  /**
   * Test functions available?
   */
  public testMode: boolean = environment.testMode

  public set(): void {
    const res = generate()
    this.control().setValue(res)
  }
}
